import React from "react";
import { useSelector } from "react-redux";
import { useLocation, useParams } from "react-router-dom";

import { saveJournal } from "../commonFetch";
import ToBack from "../components/ToBack";

export default function TopicDetails() {
  const [item, setItem] = React.useState({});
  const { id } = useParams();
  const auth = useSelector((state) => state.auth);
  const uuid = new URLSearchParams(useLocation().search).get("u_id");

  React.useEffect(() => {
    if (id && uuid) {
      fetch(`/api/bulletin/${id}?option=topic&uuid=${uuid}`)
        .then((response) => response.json())
        .then((data) => {
          setItem(data);
        });
    }
  }, [id, uuid]);

  React.useEffect(() => {
    if (!item["uuid"]) return;
    const timer = setTimeout(() => {
      saveJournal({
        ref_id: auth.id,
        ref_uuid: auth.uuid,
        ref_id2: id,
        ref_uuid2: item["uuid"],
        category: "浏览热门话题",
        tag: "个人用户",
      });
    }, 3000);
    return () => clearTimeout(timer);
  }, [item]);

  return (
    <div className="container-fluid">
      <div className="card border-0 shadow interface-bottom mt-2">
        <ToBack category={item.title} href="#" />
        <div className="card-body">
          <h6 className="text-center">{item.title}</h6>
          <div className="row" style={{ fontSize: 14 }}>
            <div className="col editor-body" dangerouslySetInnerHTML={{ __html: item.content }} />
          </div>
        </div>
      </div>
    </div>
  );
}
